import React, {useEffect, useRef, useState} from "react";
import {Typography, Link, Rating, Box, IconButton} from "@mui/material";
import {Clip, VideoContentTypes, VideoUpdatableFields} from '../../../types/clipTypes'
import {useSelectedClip} from "../../../contexts/selectedClip";
import {formatDuration} from "../../../utils/dateTimeutils";
import {useTheme} from "../../../contexts/theme";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import {findClipDescription} from "../../../utils/utils";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomRating from "../../CustomRatingComponent/CustomRatingComponent";
import VideoContentTags from "../../CommonComponents/VideoContentTags/VideoContentTags";
import fallbackThumbnail from "../../../assets/images/Login/inbriefFullWhiteR.svg";
import LoadingChip from "../../CommonComponents/LoadingChip/Loading";
import HighlightType from "../../CommonComponents/HighlightType/HighlightType";

interface ClipListElemProps{
    clip: Clip
    setMoreInfoClip?: (clipId: string) => void;
    moreInfoOpen?: boolean;
    displayMoreInfoIcon: boolean;
    noMarginTop: boolean;
    onClipImageClick?: (clip: Clip) => void;
    onClipTitleClick?: (clip: Clip) => void;
    onClipDeleteClick?: (clip: Clip) => void;
    onDeleteAllKeyMomentClips?: (event: any, keyMoment: string) => void;
    onClipUpdate?: (clipId: string, field: VideoUpdatableFields, value: string[] | string) => void;
    clipDeleting?: boolean
}

const ClipListElem: React.FC<ClipListElemProps> = ({onClipUpdate = () => {}, clipDeleting, onDeleteAllKeyMomentClips, clip, setMoreInfoClip, moreInfoOpen, noMarginTop, displayMoreInfoIcon, onClipTitleClick= () =>{}, onClipImageClick = () => {}, onClipDeleteClick}) => {
    const theme = useTheme();
    const [defaultDescription, setDefaultDescription] = useState<string>("")
    const [localDelete, setLocalDelete] = useState<boolean>(false)

    useEffect(() => {
        if(clip && clip.descriptions){
            setDefaultDescription(findClipDescription(clip))
        }
    }, [clip]);

    useEffect(() => {
        if(!clipDeleting){
            setLocalDelete(false);
        }
    }, [clipDeleting]);

    /*
    useEffect(() => {
        console.log("clip", clip.title);
    }, [clip]);

    useEffect(() => {
        console.log("setMoreInfoClip", clip.title);
    }, [setMoreInfoClip]);

    useEffect(() => {
        console.log("moreInfoOpen", moreInfoOpen);
    }, [moreInfoOpen]);

    useEffect(() => {
        console.log("displayMoreInfoIcon", displayMoreInfoIcon);
    }, [displayMoreInfoIcon]);

    useEffect(() => {
        console.log("noMarginTop", noMarginTop);
    }, [noMarginTop]);

    useEffect(() => {
        console.log("onClipImageClick", clip.title);
    }, [onClipImageClick]);

    useEffect(() => {
        console.log("onClipTitleClick", clip.title);
    }, [onClipTitleClick]);

    useEffect(() => {
        console.log("onClipDeleteClick", clip.title);
    }, [onClipDeleteClick]);

    useEffect(() => {
        console.log("onDeleteAllKeyMomentClips", clip.title);
    }, [onDeleteAllKeyMomentClips]);

    useEffect(() => {
        console.log("onClipUpdate", clip.title);
    }, [onClipUpdate]);

    useEffect(() => {
        console.log("clipDeleting", clipDeleting);
    }, [clipDeleting]);
    */

    return (
        <Box
            sx={{
                display: 'flex',
                marginTop: noMarginTop ? 0 : theme.spacing.sm,
                paddingBottom: theme.spacing.sm,
                borderBottom: `${theme.border.type.solid} ${theme.border.width.thin} ${theme.palette.lightGrey}`,
                position: 'relative'
        }}>
            {clipDeleting && localDelete && <Box
                width={'100%'}
                height={'100%'}
                sx={{backgroundColor:theme.palette.blurredBlue}}
                top={'0'}
                left={'0'}
                position={'absolute'}
                zIndex={99}
            ></Box>}
            <Box sx={{position: 'relative'}}>
                <img alt="Clip thumbnail" style={{width: '180px', height: 'auto'}} src={clip.thumbnail ? clip.thumbnail : fallbackThumbnail} onClick={() => onClipImageClick(clip)}/>
                {(onClipDeleteClick || onDeleteAllKeyMomentClips) && <DeleteIcon
                    fontSize={'small'}
                    onClick={(event) => {
                        if (onDeleteAllKeyMomentClips) {
                            onDeleteAllKeyMomentClips(event, clip.game_time + "_" + clip.key_moment_type);
                        }else if(onClipDeleteClick){
                            setLocalDelete(true);
                            onClipDeleteClick(clip)
                        }
                    }}
                    sx={{position: 'absolute', top:0, right: 0, zIndex: 1, color: theme.palette.white}}
                />}
                {clip.editing && <Box sx={{position: 'absolute', top: '70px', left: '5px'}}>
                    <LoadingChip label={'Processing'} color={theme.palette.orange} pulse={true}/>
                </Box>}
                {(clip.manual && clip.inbrief_tags && clip.inbrief_tags?.includes("manual") && !clip.inbrief_tags?.includes("superadmin")) && <Box padding={theme.spacing.xs} width={'100%'} position={'absolute'} top={0} left={0}>
                    <HighlightType highlight_type={"Manual"}/>
                </Box>}
            </Box>
            <Box sx={{paddingLeft: theme.spacing.md, marginBottom: theme.spacing.xs, height:'100%', flex: 1}}>
                <Box sx={{paddingBottom:theme.spacing.xs, display: 'flex', justifyContent: 'space-between', width:'100%'}}>
                    <Link fontSize={theme.fontSizes.subParagraphTitle} fontWeight={theme.fontWeights.subParagraphTitle} onClick={() => onClipTitleClick(clip)}>{clip.title}</Link>
                    {displayMoreInfoIcon && setMoreInfoClip && <IconButton onClick={() => setMoreInfoClip(clip.id)} sx={{color: theme.palette.orange, height: '20px'}} size={'small'}>
                        {moreInfoOpen ? <RemoveCircleIcon sx={{color: theme.palette.orange}}/> : <AddCircleIcon sx={{color: theme.palette.orange}}/>}
                    </IconButton>}
                </Box>
                <Typography
                    fontSize={theme.fontSizes.subParagraphText}
                    fontWeight={theme.fontSizes.subParagraphText}
                    sx={{marginBottom: theme.spacing.xs}}
                >
                    { defaultDescription }
                </Typography>
                <Box sx={{marginBottom: theme.spacing.xs}}>
                    <Typography component={'span'} fontSize={theme.fontSizes.subParagraphText} fontWeight={theme.fontSizes.subParagraphText}>Duration: </Typography>
                    {clip.latest_social_clip_duration && <Typography
                        component={'span'}
                        fontSize={theme.fontSizes.subParagraphText}
                        fontWeight={theme.fontSizes.subParagraphTitle}>
                        {formatDuration(clip.latest_social_clip_duration)}
                    </Typography>}
                </Box>
                <CustomRating auto_rating={clip.auto_rating} manual_rating={clip.manual_rating} clipId={clip.id}/>
                <VideoContentTags
                    tags={clip.tags ? clip.tags : []}
                    contentType={'clip'}
                    label={'Tags:'}
                    onTagSelected={(tags) => onClipUpdate(clip.id, 'tags', tags)}
                    labelStyle={{
                        fontSize:theme.fontSizes.subParagraphText,
                        fontWeight:theme.fontSizes.subParagraphText,
                        color:theme.palette.lightGrey,
                        marginRight: theme.spacing.xs
                    }}
                />
            </Box>
        </Box>
    );
};

export default React.memo(ClipListElem);